import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {iconaCripto, moneteDelTicker} from './cripto';
import {pieDiPagina} from '../../moduli/leggi';

/**
 * IL TICKER DELLE CRIPTOVALUTE nel piede Nova: le monete che NOWPayments
 * accetta (cripto.js), ognuna col suo logo, la sigla e il nome, in DUE
 * RIGHE che scorrono di continuo in versi opposti (quella sopra verso
 * destra, quella sotto verso sinistra) e, fra le due, una frase a effetto
 * («ACCETTIAMO PIÙ DI 50 CRYPTO!» di serie). E' un elemento di FIDUCIA e
 * di disegno, non un comando: non si clicca (pointer-events: none, nessun
 * collegamento), non si ferma sotto il mouse, e il lettore di schermo salta
 * le righe e legge la frase e, al posto delle monete, una riga sola. Con
 * «meno animazioni» sta ferma.
 *
 * Lo scorrimento e' CSS (Nova.css, .nova-ticker): ogni riga e' scritta due
 * volte di fila e la pista si sposta di meta' della sua larghezza, cosi'
 * quando la prima copia e' passata si riparte senza salti. La durata cresce
 * col numero di monete della riga, cosi' la velocita' resta la stessa.
 * I riquadri sono in rilievo come quelli della fascia fornitori, con lo
 * stesso riflesso di luce che passa (--i e' la posizione nella riga).
 *
 * Lo accende e lo spegne il modulo Piè di pagina (Criptovalute accettate),
 * che sceglie anche quali monete scorrono e in che ordine (Monete del
 * ticker: le sigle che il sito non conosce si saltano, e se non ne resta
 * nessuna scorrono tutte) e scrive la frase (Frase fra le due righe).
 */
export default function TickerCripto() {
  const {t} = useTranslation();
  const piede = pieDiPagina();
  const monete = moneteDelTicker(piede.cripto.monete);
  const frase = piede.cripto.frase;
  const meta = Math.ceil(monete.length / 2);
  /* FERMO QUANDO NON SI VEDE. Le due righe e i riflessi sono un centinaio di
     animazioni che non finiscono mai, e il ticker sta nel piede: quasi
     sempre fuori dallo schermo, ma il browser le ricalcolava lo stesso a ogni
     fotogramma. Misurato su un telefono lento, nella pagina sport: mezzo
     secondo di lavoro in piu' a ogni tocco su una quota. Ora si muovono solo
     mentre il piede e' in vista; parte fermo e si accende quando arriva. */
  const piedeRef = useRef(null);
  const [inVista, setInVista] = useState(false);
  useEffect(() => {
    const nodo = piedeRef.current;
    if (!nodo || typeof IntersectionObserver === 'undefined') {
      setInVista(true);
      return undefined;
    }
    const osserva = new IntersectionObserver(([voce]) => setInVista(voce.isIntersecting));
    osserva.observe(nodo);
    return () => osserva.disconnect();
  }, []);
  return (
    <div ref={piedeRef} className={'nova-ticker' + (inVista ? '' : ' fermo')}>
      <p className={'nova-sr'}>
        {t('Accettiamo {{quante}} criptovalute con NOWPayments, fra cui Bitcoin, Ethereum e Tether.', {quante: monete.length})}
      </p>
      <Riga monete={monete.slice(0, meta)} verso={'destra'}/>
      {frase && <p className={'nova-ticker-frase'}>{frase}</p>}
      <Riga monete={monete.slice(meta)} verso={'sinistra'}/>
    </div>
  );
}

/** Una riga che scorre: le sue monete due volte di fila, verso `destra` o `sinistra`. */
function Riga({monete, verso}) {
  if (!monete.length) return null;
  const lista = monete.concat(monete);
  return (
    <div className={'nova-ticker-riga ' + verso} aria-hidden={'true'}>
      <div className={'nova-ticker-pista'} style={{'--n-ticker-durata': (monete.length * 3.2) + 's'}}>
        {lista.map((m, n) => (
          <span key={m.sigla + n} className={'nova-ticker-moneta'} style={{'--i': n % monete.length}}>
            <img src={iconaCripto(m.sigla)} alt={''} width={'40'} height={'40'} loading={'lazy'} draggable={false}/>
            <span><b>{m.sigla}</b><small>{m.nome}</small></span>
          </span>
        ))}
      </div>
    </div>
  );
}
